// extracted by mini-css-extract-plugin
module.exports = {"video-container":"videoComponent_video-container__2ohtY"};